/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Performancetable_Chartview2Inputs */

const id_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan grafik`)
};

const ms_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paparan carta`)
};

const da_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramvisning`)
};

const de_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagrammansicht`)
};

const en_us2_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart view`)
};

const es_es2_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de gráfico`)
};

const es_mx2_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de gráfico`)
};

const fil_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart view`)
};

const fr_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue en graphique`)
};

const it_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista grafico`)
};

const hu_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram nézet`)
};

const nl_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafiekweergave`)
};

const no_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramvisning`)
};

const pl_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widok wykresu`)
};

const pt_br2_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart view`)
};

const pt_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de gráfico`)
};

const ro_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vizualizare grafic`)
};

const fi_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaavionäkymä`)
};

const sv_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagramvy`)
};

const vi_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem dạng biểu đồ`)
};

const tr_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grafik görünümü`)
};

const cs_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazení grafu`)
};

const bg_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изглед на диаграма`)
};

const ru_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид графиком`)
};

const uk_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вид графіком`)
};

const ar_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض الرسم البياني`)
};

const hi_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चार्ट दृश्य`)
};

const th_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มุมมองแผนภูมิ`)
};

const ja_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャート表示`)
};

const zh_cn2_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图表视图`)
};

const zh_hant1_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chart view`)
};

const ko_components_performancetable_chartview2 = /** @type {(inputs: Components_Performancetable_Chartview2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`차트 보기`)
};

/**
* | output |
* | --- |
* | "Chart view" |
*
* @param {Components_Performancetable_Chartview2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_chartview2 = /** @type {((inputs?: Components_Performancetable_Chartview2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Chartview2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_chartview2(inputs)
	if (locale === "ms") return ms_components_performancetable_chartview2(inputs)
	if (locale === "da") return da_components_performancetable_chartview2(inputs)
	if (locale === "de") return de_components_performancetable_chartview2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_chartview2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_chartview2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_chartview2(inputs)
	if (locale === "fil") return fil_components_performancetable_chartview2(inputs)
	if (locale === "fr") return fr_components_performancetable_chartview2(inputs)
	if (locale === "it") return it_components_performancetable_chartview2(inputs)
	if (locale === "hu") return hu_components_performancetable_chartview2(inputs)
	if (locale === "nl") return nl_components_performancetable_chartview2(inputs)
	if (locale === "no") return no_components_performancetable_chartview2(inputs)
	if (locale === "pl") return pl_components_performancetable_chartview2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_chartview2(inputs)
	if (locale === "pt") return pt_components_performancetable_chartview2(inputs)
	if (locale === "ro") return ro_components_performancetable_chartview2(inputs)
	if (locale === "fi") return fi_components_performancetable_chartview2(inputs)
	if (locale === "sv") return sv_components_performancetable_chartview2(inputs)
	if (locale === "vi") return vi_components_performancetable_chartview2(inputs)
	if (locale === "tr") return tr_components_performancetable_chartview2(inputs)
	if (locale === "cs") return cs_components_performancetable_chartview2(inputs)
	if (locale === "bg") return bg_components_performancetable_chartview2(inputs)
	if (locale === "ru") return ru_components_performancetable_chartview2(inputs)
	if (locale === "uk") return uk_components_performancetable_chartview2(inputs)
	if (locale === "ar") return ar_components_performancetable_chartview2(inputs)
	if (locale === "hi") return hi_components_performancetable_chartview2(inputs)
	if (locale === "th") return th_components_performancetable_chartview2(inputs)
	if (locale === "ja") return ja_components_performancetable_chartview2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_chartview2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_chartview2(inputs)
	return ko_components_performancetable_chartview2(inputs)
});
export { components_performancetable_chartview2 as "components.performanceTable.chartView" }